import { http } from 'services/http';
import { WAREHOUSE_TASK_GET_ONE, WAREHOUSE_TASK_ITEMS_GET_MANY } from 'api/query-keys.ts';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

interface IDeleteWhTaskItemsVariables {
  whTaskId: number;
  whTaskItemIds: number[];
}

export const useDeleteWhTaskItems = () => {
  return useMutationBase<void, unknown, IDeleteWhTaskItemsVariables>({
    mutationFn: async (variables) => {
      const { whTaskId, whTaskItemIds } = variables;
      const res = await http.delete(`/v1/warehouse-tasks/${whTaskId}/warehouse-task-items`, {
        data: { warehouseTaskItemIds: whTaskItemIds },
      });

      return res.data;
    },

    invalidateCallback: (_, { whTaskId }) => [
      [WAREHOUSE_TASK_GET_ONE, whTaskId],
      [WAREHOUSE_TASK_ITEMS_GET_MANY, whTaskId],
    ],
  });
};
